import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import Image from 'next/image';
import Img from '@@client/components/Img';
import SlideOpen from './SlideOpen';
import LinksAboutUs from './footer/LinksAboutUs';
import LinksCustomerResources from './footer/LinksCustomerResources';
import LinksFindUsedParts from './footer/LinksFindUsedParts';
import LinksSellAVehicle from './footer/LinksSellAVehicle';
import LinksContactUs from './footer/LinksContactUs';
var photoFloatStyle = {
  styles: /*#__PURE__*/_jsx(_JSXStyle, {
    id: "1589671232",
    children: [".jsx-1589671232{width:100%;height:auto;}"]
  }),
  className: "jsx-1589671232"
};
var photoFillStyle = {
  styles: /*#__PURE__*/_jsx(_JSXStyle, {
    id: "3160187906",
    children: [".jsx-3160187906{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;}"]
  }),
  className: "jsx-3160187906"
};
var padRightMobile = '24px';
export var GrayBarContent = function GrayBarContent(_ref) {
  var src = _ref.src,
      width = _ref.width,
      height = _ref.height,
      alt = _ref.alt,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-1421234127" + " " + 'container',
      children: /*#__PURE__*/_jsx("div", {
        className: "jsx-1421234127" + " " + 'pad-left-gutter pad-right-gutter padder',
        children: /*#__PURE__*/_jsxs("div", {
          className: "jsx-1421234127" + " " + 'inner',
          children: [/*#__PURE__*/_jsx("div", {
            className: "jsx-1421234127" + " " + 'image',
            children: /*#__PURE__*/_jsx(ImageByType, {
              width: width,
              height: height,
              src: src,
              alt: alt,
              className: photoFloatStyle.className
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "jsx-1421234127" + " " + 'content',
            children: children
          })]
        })
      })
    }), photoFloatStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1421234127",
      children: [".container.jsx-1421234127{background:#EDEEF2;}", "@media(min-width:992px){.padder.jsx-1421234127{padding-right:0;}}", "@media(min-width:992px){.inner.jsx-1421234127{display:grid;grid-template-columns:4fr 4fr;}}", ".image.jsx-1421234127{padding:".concat(padRightMobile, " 0 0 0;}"), "@media(min-width:992px){.image.jsx-1421234127{padding:40px 50px 30px 0;}}", ".content.jsx-1421234127{padding:".concat(padRightMobile, " 0;}"), "@media(min-width:992px){.content.jsx-1421234127{padding:40px 30px 40px 0;}}"]
    })]
  });
};
export var NarrowContent = function NarrowContent(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-1767696566" + " " + 'content',
      children: children
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1767696566",
      children: [".content.jsx-1767696566{max-width:600px;font-size:1.125rem;}"]
    })]
  });
};

var ImageByType = function ImageByType(_ref3) {
  var width = _ref3.width,
      height = _ref3.height,
      src = _ref3.src,
      alt = _ref3.alt,
      className = _ref3.className;

  // relative, use next/image
  if (/^\//.test(src)) {
    return /*#__PURE__*/_jsx(Image, {
      width: width,
      height: height,
      src: src,
      alt: alt,
      className: className
    });
  } else {
    return /*#__PURE__*/_jsx(Img, {
      width: width,
      height: height,
      src: src,
      alt: alt,
      className: className
    });
  }
};

export var ContentAndPhoto = function ContentAndPhoto(_ref4) {
  var src = _ref4.src,
      width = _ref4.width,
      height = _ref4.height,
      alt = _ref4.alt,
      children = _ref4.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-508327108" + " " + 't-md',
      children: /*#__PURE__*/_jsx("div", {
        className: "jsx-508327108" + " " + 'image',
        children: /*#__PURE__*/_jsx(ImageByType, {
          width: width,
          height: height,
          src: src,
          alt: alt,
          className: photoFillStyle.className
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "jsx-508327108" + " " + 'pad-left-gutter pad-right-gutter padder',
      children: /*#__PURE__*/_jsxs("div", {
        className: "jsx-508327108" + " " + 'inner',
        children: [/*#__PURE__*/_jsx("div", {
          className: "jsx-508327108" + " " + 'content',
          children: children
        }), /*#__PURE__*/_jsx("div", {
          className: "jsx-508327108" + " " + 'a-lg',
          children: /*#__PURE__*/_jsx("div", {
            className: "jsx-508327108" + " " + 'image',
            children: /*#__PURE__*/_jsx(ImageByType, {
              width: width,
              height: height,
              src: src,
              alt: alt,
              className: photoFillStyle.className
            })
          })
        })]
      })
    }), photoFillStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "508327108",
      children: ["@media(min-width:992px){.padder.jsx-508327108{padding-right:0;}}", ".inner.jsx-508327108{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;}", "@media(min-width:992px){.inner.jsx-508327108{display:grid;grid-template-columns:4fr 4fr;}}", ".content.jsx-508327108{padding:".concat(padRightMobile, " 0;}"), "@media(min-width:992px){.content.jsx-508327108{padding:40px 30px 40px 0;}}"]
    })]
  });
};
export var Content = function Content(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-2502315517" + " " + 'pad-left-gutter pad-right-gutter padder',
      children: /*#__PURE__*/_jsx("div", {
        className: "jsx-2502315517" + " " + 'container',
        children: children
      })
    }), photoFillStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2502315517",
      children: ["@media(min-width:992px){.padder.jsx-2502315517{padding-right:0;}}", ".container.jsx-2502315517{padding:".concat(padRightMobile, " 0;}"), "@media(min-width:992px){.container.jsx-2502315517{padding:40px 30px 40px 0;}}"]
    })]
  });
};
export var Header = function Header(_ref6) {
  var title = _ref6.title,
      children = _ref6.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-3406663623" + " " + 'container page-padding-tb pad-left-gutter pad-right-gutter',
      children: [/*#__PURE__*/_jsx("h1", {
        className: "jsx-3406663623",
        children: title
      }), /*#__PURE__*/_jsx("div", {
        className: "jsx-3406663623" + " " + 'content',
        children: children
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3406663623",
      children: [".container.jsx-3406663623{background:#DBE9F9;}", "@media(min-width:992px){.container.jsx-3406663623{padding-right:".concat(padRightMobile, ";}}"), ".content.jsx-3406663623{font-size:1.5rem;color:#21409A;}"]
    })]
  });
};
export default function GeneralPage(_ref7) {
  var children = _ref7.children,
      heading = _ref7.heading,
      leadContent = _ref7.leadContent;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-3737699951" + " " + 'container',
      children: [/*#__PURE__*/_jsx("div", {
        className: "jsx-3737699951" + " " + 'main',
        children: children
      }), /*#__PURE__*/_jsx("div", {
        className: "jsx-3737699951" + " " + 'sidebar a-lg page-padding-tb pad-right-gutter',
        children: /*#__PURE__*/_jsxs("div", {
          className: "jsx-3737699951" + " " + 'menus',
          children: [/*#__PURE__*/_jsx(SlideOpen, {
            id: "sidebar-general-info",
            title: "Customer Resources",
            children: /*#__PURE__*/_jsx(LinksCustomerResources, {})
          }), /*#__PURE__*/_jsx(SlideOpen, {
            id: "sidebar-about-us",
            title: "About Us",
            children: /*#__PURE__*/_jsx(LinksAboutUs, {})
          }), /*#__PURE__*/_jsx(SlideOpen, {
            id: "sidebar-find-parts",
            title: "Find Used Parts",
            children: /*#__PURE__*/_jsx(LinksFindUsedParts, {})
          }), /*#__PURE__*/_jsx(SlideOpen, {
            id: "sidebar-sell-vehicle",
            title: "Sell a Vehicle",
            children: /*#__PURE__*/_jsx(LinksSellAVehicle, {})
          }), /*#__PURE__*/_jsx(SlideOpen, {
            id: "sidebar-contact-us",
            title: "Contact us",
            children: /*#__PURE__*/_jsx(LinksContactUs, {
              chatButtonClassName: "m--as-link"
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3737699951",
      children: ["@media(min-width:992px){.container.jsx-3737699951{display:grid;grid-template-columns:4fr 1.8fr;}}", ".sidebar.jsx-3737699951{background:#F0F1F6;padding-left:20px;}", ".menus.jsx-3737699951{width:250px;}", ".sidebar.jsx-3737699951 .slide-open{width:100%;border:0;background:-webkit-gradient(linear,left top,left bottom,from(#1C357D),to(#182661));background:linear-gradient(#1C357D,#182661);margin-bottom:20px;}", ".sidebar.jsx-3737699951 .slide-open .action-open{padding:8px 20px;font-weight:700;text-transform:uppercase;}", ".sidebar.jsx-3737699951 .slide-open .dropdown{padding:8px 20px;background:white;}", ".sidebar.jsx-3737699951 .slide-open .dropdown button.m--as-link,.sidebar.jsx-3737699951 .slide-open .dropdown a{color:#21409A;-webkit-text-decoration:underline;text-decoration:underline;}", ".sidebar.jsx-3737699951 .slide-open .dropdown button.m--as-link:hover,.sidebar.jsx-3737699951 .slide-open .dropdown a:hover{color:#8BBBFF;}"]
    })]
  });
}